import { render, staticRenderFns } from "./cElementEdit.vue?vue&type=template&id=21cf6ab0&scoped=true&"
import script from "./cElementEdit.vue?vue&type=script&lang=js&"
export * from "./cElementEdit.vue?vue&type=script&lang=js&"
import style0 from "./cElementEdit.vue?vue&type=style&index=0&id=21cf6ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cf6ab0",
  null
  
)

export default component.exports